import { DisplayWindowPlatform } from '../platform/types'
import { WindowMessage } from '../types'

export class WebDisplayWindowPlatform implements DisplayWindowPlatform {
	private messageHandlers: ((message: WindowMessage) => void)[] = []

	constructor() {
		// Listen for messages from main window
		this.handleMessage = this.handleMessage.bind(this)
		window.addEventListener('message', this.handleMessage)
	}

	sendToMain(message: WindowMessage): void {
		// Web platform uses window.opener.postMessage
		window.opener?.postMessage(message, window.location.origin)
	}

	onMessageFromMain(handler: (message: WindowMessage) => void): () => void {
		this.messageHandlers.push(handler)

		// Return cleanup function
		return () => {
			const index = this.messageHandlers.indexOf(handler)
			if (index > -1) {
				this.messageHandlers.splice(index, 1)
			}
		}
	}

	cleanup(): void {
		window.removeEventListener('message', this.handleMessage)
	}

	private handleMessage = (event: MessageEvent<WindowMessage>) => {
		// Verify origin for security
		if (event.origin !== window.location.origin) {
			return
		}

		// Forward to all registered handlers
		this.messageHandlers.forEach(handler => handler(event.data))
	}
}
